export default __webpack_public_path__ + "static/media/pexels-chanaka-318741-906494 (1).39af777c.jpg";